export default "__VITE_ASSET___7ABbRd4__"